import React from "react";

export default function MaximusSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="210"
      height="28"
      fill="none"
      viewBox="0 0 210 28"
    >
      <path
        fill="#6B7280"
        fillRule="evenodd"
        d="M13.027 2.54c-.745 1.196-3.98 6.72-7.191 12.273C2.626 20.366 0 25.406 0 26.013c0 .741 2.438 1.103 7.428 1.103h7.427l3.657-6.25 3.657-6.251 3.744 6.25 3.743 6.251h7.573c4.165 0 7.573-.288 7.573-.638 0-.352-3.25-6.358-7.223-13.346C33.605 6.143 29.959.426 29.476.426c-.483 0-.888.32-.9.715-.012.393-1.469 3.038-3.238 5.88l-3.215 5.166-3.05-5.404C17.395 3.81 15.653 1.15 15.202.872c-.452-.279-1.43.472-2.176 1.668z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#6B7280"
        fillRule="evenodd"
        d="M22.34 14.766l.047-.08 3.864 6.47 3.863 6.468h7.814c4.3 0 7.816-.298 7.816-.66 0-.365-3.355-6.58-7.455-13.813-4.1-7.233-7.863-13.15-8.36-13.15-.5 0-.917.332-.93.739-.012.407-1.515 3.145-3.34 6.086l-3.319 5.346v2.594z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#6B7280"
        d="M53.696 26.7h3.263V8.566l8.381 9.68h.297l8.418-9.68V26.7h3.263V.185h-.297l-11.533 13.61L53.993.185h-.297V26.7zM79.926 26.7h3.412l2.15-5.229h12.683l2.151 5.23h3.412L91.978 0h-.297L79.926 26.7zm6.712-7.936L91.83 6.156l5.228 12.608h-10.42zM104.479 26.7h3.746l7.231-10.717 7.046 10.717h3.745L117.422 13.5 126.173.742h-3.745l-7.009 10.346L108.225.742h-3.746l9.012 12.756-9.012 13.202zM129.806 26.7h3.263V.742h-3.263V26.7zM138.476 26.7h3.263V8.566l8.381 9.68h.296l8.418-9.68V26.7h3.264V.185h-.297l-11.533 13.61L138.772.185h-.296V26.7zM177.092 27.257c5.97 0 10.123-3.783 10.123-10.124V.742h-3.263v16.39c0 4.562-2.633 7.195-6.86 7.195-4.228 0-6.861-2.633-6.861-7.194V.742h-3.263v16.39c0 6.342 4.153 10.125 10.124 10.125zM199.891 27.182c5.377 0 9.234-2.818 9.234-7.416 0-4.784-4.154-6.49-7.899-8.085-3.152-1.297-5.897-2.484-5.897-5.154 0-2.04 1.558-3.56 4.636-3.56 2.151 0 4.19.741 5.451 2.596l2.336-1.632c-1.594-2.448-4.487-3.708-7.824-3.708-4.784 0-7.825 2.633-7.825 6.6 0 4.599 4.005 6.23 7.639 7.788 3.153 1.298 6.119 2.559 6.119 5.488 0 2.596-2.299 4.34-6.044 4.34-3.375 0-5.711-1.521-7.38-4.043l-2.262 1.743c2.039 3.19 5.303 5.043 9.716 5.043z"
      ></path>
    </svg>
  );
}
